  <!--btn btn-sm btn-secondary centralMenuFontStyle-->
  <ng-container *ngIf="( ie.TypeDID == IE_TYPES.CentralMenuList)">
    <button [class]="centralMenuClass" mat-icon-button [matMenuTriggerFor]="menu" aria-label="">
       <mat-icon>menu</mat-icon>
    </button>
    <mat-menu  #menu="matMenu">
      <button mat-menu-item *ngFor="let iee of centralMenuItemList">
        <app-cosy-html 
            [ieList]="[iee]" [sessionID]="sessionID" (switchToAppCall)="switchToAppCall($event)">
        </app-cosy-html>
      </button>
      <button mat-menu-item (click)="logoutFromApp()">Logout</button>
    </mat-menu>
  </ng-container>


  <ng-container class="" *ngIf="( ie.TypeDID == IE_TYPES.MenuList && ie.CustomizeOptions != null && ie.CustomizeOptions.DisplayType == 'tree')">
    <app-html-tree 
      [ie]="ie" 
      (onSelectNode)="onNotifySelectNode($event)" 
      (onNodeDrag)="fetchIEUserAction(ie.Attributes.OnNodeDragUAID,ie.Values[0])">
    </app-html-tree>
  </ng-container>
  <ul  *ngIf="( ie.TypeDID == IE_TYPES.MenuList)" class="list-group" style="border-style:None;">
    <li class="list-group-item py-1" 
        *ngFor="let menu of menuItems" 
        [id]="ie.InterfaceElementID">
        <a *ngIf="(!menu.Selected && (menu.MenuGroup == null) && menu.DisplayName.indexOf('------')<0)"  
          href="javascript:void(0);" 
          (click)="fetchIEUserAction(menu.Attributes.OnClickUAID)">
           {{menu.DisplayName}}
        </a>
        <div *ngIf="(menu.DisplayName.indexOf('------')>-1)">
          <hr/>
        </div>
        <span *ngIf="(!menu.Selected && (menu.MenuGroup!=null&& menu.MenuGroup.Head== true && menu.MenuGroup.Member == false))"  
          href="javascript:void(0);" 
          (click)="fetchIEUserAction(menu.Attributes.OnClickUAID)">
          <div>
            <button *ngIf="menu.MenuGroup!=null && menu.MenuGroup.Head == true" (click)="onDetailViewclicked(menu)" class="btn btn-sm bg-transparent shadow-none move-left" [attr.aria-expanded]="!menu.DetailView">
              <i id="button_Angle_right" class="fa-fw"  *ngIf="!menu.MenuGroup.DetailView"></i>
              <i id="button_Angle_down" class="fa-fw" *ngIf="menu.MenuGroup.DetailView"></i>
              
            </button>
            <span style="cursor:pointer" (click)= "onDetailViewclicked(menu)">{{menu.DisplayName}}</span>
          </div>
          <div *ngIf="menu.MenuGroup!=null && menu.MenuGroup.DetailView" [id]="menu.DisplayName" [collapse]="" class="">
            <ng-container *ngFor="let member of menu.MenuGroup.Members">
              <div>
                <ng-container *ngTemplateOutlet="menuGroupSection;context:{MEMBER: member }">
                </ng-container>
             </div>
            </ng-container>
           </div>
        </span>
      <a *ngIf="(menu.Selected  && (menu.MenuGroup == null))" 
          class="menu-active" 
          href="javascript:void(0);" 
          (click)="fetchIEUserAction(menu.Attributes.OnClickUAID)">
          {{menu.DisplayName}}
      </a>
    </li>
  </ul>
  <ng-template #menuGroupSection let-member="MEMBER" >
   
    <div *ngIf="member.MenuGroup.Head!=null && member.MenuGroup.Head == true">
        <button (click)="onDetailViewclicked(member)" [class]="'btn btn-sm bg-transparent shadow-none  '+ member.MenuGroup.CSSClass" [attr.aria-expanded]="!member.DetailView">
         <i id="button_Angle_right" class="fa-fw" *ngIf="!member.MenuGroup.DetailView"></i>
         <i id="button_Angle_down" class="fa-fw" *ngIf="member.MenuGroup.DetailView"></i>
        
        </button>
        <span style="cursor:pointer" (click)="onDetailViewclicked(member)" >{{member.DisplayName}}</span>
        <div *ngIf=" member.MenuGroup.DetailView" [id]="member.DisplayName" [collapse]="" class="">
          <ng-container *ngFor="let m_member of member.MenuGroup.Members">
           <div>
              <ng-container *ngTemplateOutlet="menuGroupSection;context:{MEMBER: m_member}">
              </ng-container>
           </div>
          </ng-container>
        </div>
    </div>
    <div [class]="member.MenuGroup.CSSClass" *ngIf="member.MenuGroup.Head ==null || (member.MenuGroup.Head!= null && member.MenuGroup.Head == false)">
      <a *ngIf="(!member.Selected)" href="javascript:void(0);" 
      (click)="fetchIEUserAction(member.Attributes.OnClickUAID)">
         {{member.DisplayName}}
      </a>
      <a *ngIf="(member.Selected)" class="menu-active"  href="javascript:void(0);" 
      (click)="fetchIEUserAction(member.Attributes.OnClickUAID)">
         {{member.DisplayName}}
      </a>
    </div>
  </ng-template>


    


